module.exports = __webpack_public_path__ + "img/3&3_GRILL.5aebb44b.webp";